import {Component, ElementRef, Input, OnInit, ViewChild} from '@angular/core';
import {faFacebook, faXTwitter} from '@fortawesome/free-brands-svg-icons';
import {faShareNodes} from '@fortawesome/pro-light-svg-icons';
import {WindowRefService} from 'app/services/window-ref.service';
import {FeatureToggleService} from 'app/services/feature-toggle.service';
import {
  ShareOnSocialMediaService,
  SocialMediaType
} from '../../../services/share-on-social-media.service';
import {DiscoverV2BffService} from '../../../elements-v2/service/discover-v2-bff.service';
import {ShareOptions} from '../../../models/MetaData';
import {truncateString} from 'core/utils/string-helper';
import { EmailPopupComponent } from '../../../share-it/components/email-popup/email-popup.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ShareItResource } from '../../../share-it/models/share-it';

@Component({
  selector: 'app-share-icons-button',
  templateUrl: './share-icons-button.component.html',
  styleUrls: ['./share-icons-button.component.scss']
})
export class ShareIconsButtonComponent implements OnInit {
  @Input() public smallButton?: boolean = false;
  @Input() public bigButton?: boolean = false;
  @Input() public isSearchPage?: boolean = false;
  @Input() public disabled: boolean;
  @Input() shareData: ShareOptions;
  @Input() public resourceData?: ShareItResource;
  @Input() public displayEmailOption?: boolean = false;
  @Input() public displaySocialMediaOptions?: boolean = true;
  @ViewChild('shareIconsToggleButton') public shareIconsToggleButton: ElementRef;
  public faFacebook = faFacebook;
  public faXTwitter = faXTwitter;
  public faShareNodes = faShareNodes;
  public isSocialMediaShareEnabled: boolean;
  public shareID = Date.now();
  protected readonly SocialMediaType = SocialMediaType;

  constructor(
    private readonly windowRefService: WindowRefService,
    private readonly featureToggleService: FeatureToggleService,
    private readonly shareOnSocialMediaService: ShareOnSocialMediaService,
    private readonly discoverV2BffService: DiscoverV2BffService,
    private modal: NgbModal,
  ) {
  }

  public ngOnInit() {
    this.shareID = Date.now();
    this.isSocialMediaShareEnabled = this.featureToggleService.getToggles()['DIS-30364_2024-06-30_Social-Media-Share'];
  }

  private createTwitterShareUrl(url: string) {
    const shareTwitterUrl = this.shareOnSocialMediaService.socialMediaShareLinkHandler(SocialMediaType.TWITTER, url);
    this.windowRefService.nativeWindow().open(shareTwitterUrl, '_blank');
  }

  private createFacebookShareUrl(url: string) {
    const shareFaceBookUrl = this.shareOnSocialMediaService.socialMediaShareLinkHandler(SocialMediaType.FACEBOOK, url);
    this.windowRefService.nativeWindow().open(shareFaceBookUrl, '_blank');
  }

  public shareOnMedia(type: SocialMediaType) {
    if (this.isSearchPage) {
      const url = this.windowRefService?.nativeWindow()?.location?.href;
      const newUrl = new URL(url);
      const query = newUrl.searchParams.get('query');
      const body: ShareOptions = {
        id: this.shareID,
        title: encodeURIComponent(truncateString(query, 50)),
        description: '',
        author: '',
        image: this.shareData.image,
        url: encodeURIComponent(url)
      };

      this.discoverV2BffService.sharePage(body).subscribe(
        (data) => {
          if (type === SocialMediaType.FACEBOOK) {
            this.createFacebookShareUrl(data.file.location);
          } else {
            this.createTwitterShareUrl(data.file.location);
          }
        });
    } else {
      this.discoverV2BffService.sharePage(this.shareData).subscribe(
        (data: any) => {
          if (type === SocialMediaType.FACEBOOK) {
            this.createFacebookShareUrl(data.file.location);
          } else {
            this.createTwitterShareUrl(data.file.location);
          }
        });
    }
  }

  public onEmailAction() {
    const modalRef = this.modal.open(EmailPopupComponent, {
      windowClass: 'inspire-custom-modal',
    });

    modalRef.componentInstance.resourceData = this.resourceData;
    modalRef.result.finally(() => {
      this.shareIconsToggleButton?.nativeElement.focus();
    });
  }
}
